"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockExplorerUrl = void 0;
function getBlockExplorerUrl(params) {
    const { txId } = params;
    const protocol = params.protocol.toUpperCase();
    const coinName = params.coinName.toLowerCase();
    const txIdOrAddress = params.txId || params.address || "";
    if (protocol === "ERC20" || (protocol === "MAINNET" && coinName === "eth")) {
        return `https://etherscan.io/${txId ? "tx" : "address"}/${txIdOrAddress}`;
    }
    else if (protocol === "BEP20") {
        return `https://bscscan.com/${txId ? "tx" : "address"}/${txIdOrAddress}`;
    }
    else if (protocol === "HECO") {
        return `https://hecoinfo.com/${txId ? "tx" : "address"}/${txIdOrAddress}`;
    }
    else if (protocol === "TRC20") {
        return `https://tronscan.org/#/${txId ? "transaction" : "address"}/${txIdOrAddress}`;
    }
    else if (protocol === "OMNI") {
        return `https://omniexplorer.info/${txId ? "tx" : "address"}/${txIdOrAddress}`;
    }
    else if (coinName === "ltc") {
        return `https://blockchair.com/litecoin/${txId ? "transaction" : "address"}/${txIdOrAddress}`;
    }
    else if (coinName === "fil") {
        return `https://filfox.info/${txId ? "message" : "address"}/${txIdOrAddress}`;
    }
    else if (coinName === "atom") {
        return `https://www.mintscan.io/cosmos/${txId ? "txs" : "account"}/${txIdOrAddress}`;
    }
    else if (coinName === "xrp") {
        return `https://xrpscan.com/${txId ? "tx" : "account"}/${txIdOrAddress}`;
    }
    else if (coinName === "xrp") {
        return `https://explorer.cardano.org/en/${txId ? "transaction?id" : "address?address"}=${txIdOrAddress}`;
    }
    else {
        return `https://www.blockchain.com/explorer/${txId ? "transactions" : "addresses"}/${coinName}/${txIdOrAddress}`;
    }
}
exports.getBlockExplorerUrl = getBlockExplorerUrl;
